import { render, staticRenderFns } from "./CatalogueProductCard.vue?vue&type=template&id=8838ced8&scoped=true&"
import script from "./CatalogueProductCard.vue?vue&type=script&lang=js&"
export * from "./CatalogueProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueProductCard.vue?vue&type=style&index=0&id=8838ced8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8838ced8",
  null
  
)

export default component.exports